import style from './ClusterInfoModal.module.css';
import { useState } from 'react';
import { Switch } from 'antd';
import { useUnit } from 'effector-react';
import { changeClusterModalTitleEv } from '../../models/overviewModel/index.js';

const gmk_target_indicators = [
  {
    key: 'economic-0',
    name: 'Разведанные запасы, тонн',
    fact: 40000000,
    plan: 60000000,
    type: 'horizontal',
  },
  {
    key: 'economic-1',
    name: 'Производство рафинированной меди, тонн',
    fact: 460000,
    plan: 700000,
    type: 'horizontal',
  },
  {
    key: 'economic-2',
    name: 'Производство медного концентрата, тонн',
    fact: 3000000,
    plan: 4000000,
    type: 'horizontal',
  },
  {
    key: 'economic-3',
    name: 'Производство медной катанки, тонн',
    fact: 20000,
    plan: 150000,
    type: 'horizontal',
  },
  {
    key: 'economic-4',
    name: 'Экспорт рафинированной меди, тонн',
    fact: 480000,
    plan: 650000,
    type: 'gauge',
  },
  {
    key: 'economic-5',
    name: 'Увеличение количества добычных лицензий',
    fact: 26,
    plan: 52,
    type: 'vertical',
  },
  {
    key: 'economic-6',
    name: 'Увеличение количества разведочных лицензий',
    fact: 31,
    plan: 100,
    type: 'vertical',
  },
  {
    key: 'economic-7',
    name: 'Коэффициент восполнения запасов меди',
    fact: 0.7,
    plan: 1.2,
    type: 'vertical',
  },
  {
    key: 'economic-8',
    name: 'Добыча медной руды, тонн',
    fact: 160000000,
    plan: 280000000,
    type: 'vertical',
  },
];

const gmk_add_indicators = [
  {
    key: 'economic-0',
    name: 'Разведанные запасы, тонн',
    fact: 40000000,
    plan: 60000000,
    type: 'horizontal',
    title: 'Ёмкость рынка',
  },
  {
    key: 'economic-1',
    name: 'Производство рафинированной меди, тонн',
    fact: 460000,
    plan: 700000,
    type: 'horizontal',
    title: 'Производительность',
  },
  {
    key: 'economic-2',
    name: 'Экспорт рафинированной меди, тонн',
    fact: 480000,
    plan: 650000,
    type: 'horizontal',
    title: 'Экономический показатель',
  },
  {
    key: 'economic-3',
    name: 'Добыча медной руды, тонн',
    type: 'linegraph',
    data: [
      { year: 2025, value: 160000 },
      { year: 2026, value: 200000 },
      { year: 2027, value: 220000 },
      { year: 2028, value: 230000 },
      { year: 2029, value: 250000 },
      { year: 2030, value: 280000 },
    ],
  },
];

export default function ClusterTargetIndicators() {
  const [type, setType] = useState('target');
  const changeTitle = useUnit(changeClusterModalTitleEv);
  const onSwitch = (checked) => {
    if (checked) {
      setType('add');
      changeTitle('Дополнительные показатели');
    } else {
      setType('target');
      changeTitle(null);
    }
  };

  return (
    <div className={style.charts_cnt}>
      <div className={style.charts_switch_cnt}>
        <div className={style.charts_switch_with_text}>
          <span>Дополнительные показатели</span>
          <Switch onChange={onSwitch} />
        </div>
      </div>
      {type === 'target' ? <TargetIndicators /> : <AddTargetIndicators />}
    </div>
  );
}

function AddTargetIndicators() {
  const hCharts = gmk_target_indicators.filter((i) => i.type === 'horizontal');
  const gauge = gmk_target_indicators.find((i) => i.type === 'gauge');
  const vCharts = gmk_target_indicators.filter((i) => i.type === 'vertical');

  return (
    <div>
      <div className={style.top_charts_cnt}>
        {hCharts.map((i, idx) => (
          <HChartCard data={i} key={idx} />
        ))}
      </div>
      <div className={style.bottom_charts_cnt}>
        <div className={style.gauge_cnt}>
          <GaugeCard data={gauge} />
        </div>
        <div className={style.v_charts_cnt}>
          {vCharts.map((i, idx) => (
            <VChartCard data={i} key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
}

function TargetIndicators() {
  const hCharts = gmk_add_indicators.filter((i) => i.type === 'horizontal');
  const chart = gmk_add_indicators.find((i) => i.type === 'linegraph');

  return (
    <div>
      <div className={style.top_charts_add_cnt}>
        {hCharts.map((i, idx) => (
          <HChartCard data={i} key={idx} filled={idx === 0} />
        ))}
        <div style={{ background: 'var(--primary-bg)', height: 32 }} />
      </div>
      <div className={style.bottom_chart_graph_cnt}>
        <h3 className={style.graph_title}>{chart.name}</h3>
        <LineGraph data={chart.data} />
      </div>
    </div>
  );
}

function HChartCard({ data, filled }) {
  const factPercent = (((data?.fact ?? 1) / (data?.plan ?? 1)) * 100).toFixed(
    1
  );
  return (
    <div
      className={`${style.h_chart_card} ${
        filled ? style.h_chart_card_add : ''
      }`}
    >
      {data.title && (
        <div className={style.h_chart_top_title}>{data.title}</div>
      )}
      <span className={style.h_chart_title}>{data.name}</span>
      <div className={style.h_chart_progress_container}>
        <div className={style.h_chart_progress_item}>
          <div
            className={style.h_chart_progress_track}
            style={{ '--percent': '100%' }}
          >
            <div className={style.h_chart_progress_fill_plan} />
          </div>
          <div className={style.h_chart_label}>
            <span>План 2030</span>
            <span className={style.h_chart_value}>
              {typeof data.plan === 'number' && !Number.isNaN(data.plan)
                ? new Intl.NumberFormat('ru-KZ', {
                    notation: data.plan >= 1000000 ? 'compact' : 'standard',
                  }).format(data.plan)
                : data.plan}
            </span>
          </div>
        </div>
        <div className={style.h_chart_progress_item}>
          <div
            className={style.h_chart_progress_track}
            style={{ '--percent': `${factPercent}%` }}
          >
            <div className={style.h_chart_progress_fill_fact} />
          </div>
          <div className={style.h_chart_label}>
            <span>Факт</span>
            <span className={style.h_chart_value}>
              {typeof data.fact === 'number' && !Number.isNaN(data.fact)
                ? new Intl.NumberFormat('ru-KZ', {
                    notation: data.fact >= 1000000 ? 'compact' : 'standard',
                  }).format(data.fact)
                : data.fact}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

function VChartCard({ data }) {
  const factPercent = (((data?.fact ?? 1) / (data?.plan ?? 1)) * 100).toFixed(
    1
  );

  return (
    <div className={style.v_chart_card}>
      <span className={style.v_chart_title}>{data.name}</span>
      <div className={style.v_chart}>
        <div className={style.v_chart_col_group}>
          <div
            className={[style.v_chart_bar, style.v_chart_bar_fact].join(' ')}
            style={{ '--v-chart-height': `${factPercent}%` }}
          >
            <span className={style.v_chart_bar_value}>
              {typeof data.fact === 'number' && !Number.isNaN(data.fact)
                ? new Intl.NumberFormat('ru-KZ', {
                    notation: data.fact >= 1000000 ? 'compact' : 'standard',
                  }).format(data.fact)
                : data.fact}
            </span>
          </div>
          <span className={style.v_chart_bar_label}>Факт</span>
        </div>

        <div className={style.v_chart_col_group}>
          <div
            className={[style.v_chart_bar, style.v_chart_bar_plan].join(' ')}
            style={{ '--v-chart-height': '100%' }}
          >
            <span className={style.v_chart_bar_value}>
              {typeof data.plan === 'number' && !Number.isNaN(data.plan)
                ? new Intl.NumberFormat('ru-KZ', {
                    notation: data.plan >= 1000000 ? 'compact' : 'standard',
                  }).format(data.plan)
                : data.plan}
            </span>
          </div>
          <span className={style.v_chart_bar_label}>План 2030</span>
        </div>
      </div>
    </div>
  );
}

function GaugeCard({ data }) {
  const factPercent = (((data?.fact ?? 1) / (data?.plan ?? 1)) * 100).toFixed(
    2
  );

  return (
    <div className={style.gauge_card}>
      <span className={style.gauge_title}>{data.name}</span>

      <div className={style.gauge_visual_group}>
        <div className={style.gauge_wrapper}>
          <div
            className={style.gauge_arc}
            style={{ '--percent': factPercent }}
          />
          <div className={style.gauge_content}>
            <span className={style.gauge_value}>
              {typeof data.fact === 'number' && !Number.isNaN(data.fact)
                ? new Intl.NumberFormat('ru-KZ', {
                    notation: data.fact >= 1000000 ? 'compact' : 'standard',
                  }).format(data.fact)
                : data.fact}
            </span>
            <span className={style.gauge_percent}>
              {Math.round(factPercent)}%
            </span>
          </div>
        </div>

        <div className={style.gauge_borders}>
          <span className={style.min_text}>0</span>
          <span>
            {typeof data.plan === 'number' && !Number.isNaN(data.plan) // Changed to use Plan as max value
              ? new Intl.NumberFormat('ru-KZ', {
                  notation: data.plan >= 1000000 ? 'compact' : 'standard',
                }).format(data.plan)
              : data.plan}
          </span>
        </div>
      </div>

      <div className={style.gauge_legend}>
        <div className={style.legend_item}>
          <div className={style.legend_fact_dot} />
          <span className={style.legend_text}>Факт</span>
        </div>
        <div className={style.legend_item}>
          <div className={style.legend_plan_dot} />
          <span className={style.legend_text}>План 2030</span>
        </div>
      </div>
    </div>
  );
}

function LineGraph({ data }) {
  // Configuration
  const width = 800;
  const height = window.innerWidth >= 1440 ? 150 : 200;
  const padding = { top: 10, bottom: 30, left: 40, right: 40 };
  const chartHeight = height - padding.top - padding.bottom;
  const chartWidth = width - padding.left - padding.right;

  // Axis Limits (Hardcoded based on your image visuals, or dynamic)
  const minVal = 100000;
  const maxVal = 300000;
  const yTicks = [100000, 150000, 200000, 250000, 300000]; // Specific ticks from image, or generate dynamically

  // Helper: Normalize Y value to pixel coordinate
  const getY = (val) => {
    return (
      chartHeight -
      ((val - minVal) / (maxVal - minVal)) * chartHeight +
      padding.top
    );
  };

  // Helper: Normalize X index to pixel coordinate
  const getX = (index) => {
    return (index / (data.length - 1)) * chartWidth + padding.left;
  };

  // Generate Path Strings
  const points = data.map((d, i) => `${getX(i)},${getY(d.value)}`).join(' ');
  const areaPoints = `${padding.left},${height - padding.bottom} ${points} ${
    width - padding.right
  },${height - padding.bottom}`;

  const formatVal = (val) =>
    new Intl.NumberFormat('ru-KZ', { notation: 'standard' }).format(val);

  return (
    <div className={style.graph_container}>
      <svg viewBox={`0 0 ${width} ${height}`} className={style.graph_svg}>
        <defs>
          <linearGradient id="blueGradient" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#2F54EB" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#2F54EB" stopOpacity="0.05" />
          </linearGradient>
        </defs>

        {/* Y-Axis Grid & Labels */}
        {yTicks.map((tick) => {
          const y = getY(tick);
          return (
            <g key={tick} className={style.grid_line}>
              <line
                x1={padding.left}
                y1={y}
                x2={width - padding.right}
                y2={y}
              />
              <text x={padding.left - 8} y={y + 4} textAnchor="end">
                {formatVal(tick)}
              </text>
            </g>
          );
        })}

        {/* X-Axis Labels */}
        {data.map((d, i) => (
          <text
            key={d.year}
            x={getX(i)}
            y={height - 16}
            textAnchor={
              i === 0 ? 'start' : i === data.length - 1 ? 'end' : 'middle'
            }
            className={style.axis_label}
          >
            {d.year}
          </text>
        ))}

        {/* Area Fill */}
        <polygon points={areaPoints} fill="url(#blueGradient)" />

        {/* Line Stroke */}
        <polyline points={points} fill="none" className={style.chart_line} />

        {/* Data Points & Value Labels */}
        {data.map((d, i) => (
          <g key={i} className={style.data_point}>
            {/* The Text Label Above Point */}
            <text
              x={getX(i)}
              y={getY(d.value) - 15}
              textAnchor={
                i === 0 ? 'start' : i === data.length - 1 ? 'end' : 'middle'
              }
              className={style.value_label}
            >
              {formatVal(d.value)}
            </text>
            {/* The Dot */}
            <circle cx={getX(i)} cy={getY(d.value)} r={5} />
          </g>
        ))}
      </svg>
    </div>
  );
}
